module.exports = __webpack_public_path__ + "img/home_icon.2dc985f1.png";